
<template>
    <el-dialog title="邀请师傅" :visible.sync="dialogInvite"  width="30%">
        <div class="container" style="text-align: center;">
            <p style="text-align: center;">请用手机扫描微信二维码</p>
            <img :src="WeChatimg" style="width:300px;"/>
        </div>
    </el-dialog>
</template>
<script>
    export default {
        data() {
            return {
                dialogInvite : false,
                WeChatimg : 'https://www.91worker.cn/wxstatic/images/wechat.jpg'
            }
        },
        mounted() {},
        methods: {
           setsataus(){
                this.dialogInvite = true;
            },
        }
    }
</script>